import { Grid, Box, Button, SvgIcon, Link, Stack, useMediaQuery, Skeleton, useTheme } from '@mui/material';
import { Eye, Save01 } from '../../../assets';
import { useContext } from 'react';
import { InvoiceDetailsContext, InvoiceDetailsValues } from '../contexts/InvoicesContext';
import PageTitle from '../../../components/shared/PageTitle';
import CustomBreadCrumbs from '../../../components/ui/CustomBreadCrumbs';
import { Link as RouterLink } from 'react-router-dom';

const InvoiceDetailsTitleArea = () => {
  const { t, data, navigate, saveInvoice, isLoading } = useContext(InvoiceDetailsContext) as InvoiceDetailsValues;
  const theme = useTheme();
  const isMobile = useMediaQuery(`(max-width:${theme.breakpoints.values.lg}px)`);

  return <Grid item
    xs={12}>
    <CustomBreadCrumbs title={t('title')}>
      <Link to="/invoices"
        component={RouterLink}>Invoices</Link>
    </CustomBreadCrumbs>
    <Stack width='100%'
      spacing={2}
      direction={isMobile ? 'column' : 'row'}
      sx={{
        justifyContent: 'space-between',
      }}>
      <Box width={isMobile ? '100%' : 'auto'}>
        <PageTitle>{t('title')}</PageTitle>
      </Box>
      <Box>
        {isLoading ? <Skeleton variant='rectangular'
          sx={{ borderRadius: '12px' }}
          width={120}
          height={40}></Skeleton> :
          <>
            {(data?.purchaseOrderHeaderId &&
              data?.purchaseOrderHeaderId > 0) ?
              <Button size='lg'
                startIcon={<SvgIcon><Eye></Eye></SvgIcon>}
                variant='secondary'
                onClick={() => navigate('/create-goods-receipt/' + data?.purchaseOrderHeaderId)}
                sx={{ mr: 4 }}>
                {t('viewPurchaseOrder')}
              </Button> : <></>}
            {<Button size='lg'
              onClick={saveInvoice}
              startIcon={<SvgIcon><Save01></Save01></SvgIcon>}>
              {t('save')}
            </Button>}
          </>}
      </Box>
    </Stack>
  </Grid>;
};

export default InvoiceDetailsTitleArea;